import { render, staticRenderFns } from "./SkeletonLoaderDocumentCreate.vue?vue&type=template&id=013fea68"
import script from "./SkeletonLoaderDocumentCreate.vue?vue&type=script&lang=js"
export * from "./SkeletonLoaderDocumentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013fea68')) {
      api.createRecord('013fea68', component.options)
    } else {
      api.reload('013fea68', component.options)
    }
    module.hot.accept("./SkeletonLoaderDocumentCreate.vue?vue&type=template&id=013fea68", function () {
      api.rerender('013fea68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documents/components/SkeletonLoaderDocumentCreate.vue"
export default component.exports